import ValidateError from '../ValidateError';
import context from '../../../../main';

export default {
  valid(question, answer) {
    if (!question.required) {
      return;
    }

    const optionList = answer?.options;
    const answeredNum = optionList.length || 0;
    let length = 1;
    let index = 0;
    let { options } = question;
    let option = {};
    // eslint-disable-next-line no-loop-func
    while (optionList[index]?.id && options.find(opt => (opt.id === optionList[index]?.id))) {
      // eslint-disable-next-line no-loop-func
      option = options.find(opt => (opt.id === optionList[index]?.id));
      if (option?.children) {
        options = option.children;
        length += 1;
      }
      index += 1;
    }
    if (answeredNum < length) {
      throw new ValidateError(context.$t('check_required'));
    }
  },
};
